import { useState, useCallback, useLayoutEffect} from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Spin, Tabs } from 'antd';
import 'antd/dist/antd.min.css'
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { format, startOfMonth, endOfMonth } from "date-fns"
import StorageService from "../../../utils/storage.service";
import _ from "lodash"

import ReportBHVVOverview from "./ReportBHVVOverview";
import ReportBHVVDetail from "./ReportBHVVDetail";

const ReportBHVV = (props) => {
    let date = new Date();
    // date.setDate(date.getDate() - 1);
    let month = date.getMonth()
    let year = date.getFullYear()
    if (date.getMonth() == 0) {
        month = 12
        year = year - 1
    }
    let oldMonth = year + '-' + month + '-'
    let day = date.getDate()
    let endOfMonth1 = new Date(endOfMonth(new Date(date)))
    let endOfMonthOld = new Date(endOfMonth(new Date(oldMonth + day)))
    if (day == endOfMonth1.getDate()) {
        day = endOfMonthOld.getDate()
    }

    let olDate = new Date(oldMonth + day)

    const [pageSize, setPageSize] = useState(10)
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(date)),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(date), 'yyyy-MM-dd'))
    const [startOldDate, setStartOldDate] = useState(format(new Date(startOfMonth(olDate)),"yyyy-MM-dd"))
    const [endOldDate, setEndOldDate] = useState(format(new Date(olDate), 'yyyy-MM-dd'))

    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [sortBy, setSortBy] = useState(0)
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [selectUser, setSelectUser] = useState('')

    const [rows, setRows] = useState([])
    const [rowsDetail, setRowsDetail] = useState([])

    const handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
        handleOleDate(sDate, eDate)
    }, [startDate, endDate])

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])
    
    const handleRangeDateOld = useCallback((sDate, eDate) => {
        setStartOldDate(sDate)
        setEndOldDate(eDate)
       
    }, [startOldDate, endOldDate])

    const handleOleDate = async (start, end) => {
        start = new Date(start)
        end = new Date(end)
        let oldMonth = start.getFullYear() + '-' + start.getMonth() + '-'
        let olDate = format(new Date(startOfMonth(new Date(oldMonth + start.getDate()))), 'yyyy-MM-dd' )
        let olEndDate = format(new Date(new Date(oldMonth + end.getDate())), 'yyyy-MM-dd' )
        setStartOldDate(olDate)
        setEndOldDate(olEndDate)
    }
    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, endDate, startDate)
    }, [store, endDate, startDate])
    
    const fetchData = async (s, eD, sD) => {
        const rs = await axiosService(`api/reports-view/tracking-bhvv?storeId=${s}&startDate=${sD}&endDate=${eD}`, "GET")
        const { dataTable, groupedByService } = rs.data.data
        if (rs.status == 200) {
            setRows(dataTable)
            setRowsDetail(groupedByService)
            setLoading(false)
        }
    }

    const selectListUser = (e) => {
        setSelectUser(e.toString())
    }

    const handleExportData = async () => {
        setLoading(true);

        try {
            const header = {
                store_name: "Cơ sở",
                totalCusHasBHVV: "Khách tới cơ sở",
                totalServiceBHVV: "Dịch vụ đã phục vụ",
                totalCusBHVVBuy: "Số khách mua hàng",
                totalServiceBuy: "Số dịch vụ mua",
                revenueCusBHVVBuy: "Doanh số thuần",
                totalActualRevenue: "Thực thu"
            };

            const listExport = [
                _.values(header),
                ..._.map(
                    rows,
                    item => _.values(_.pick(item, _.keys(header)))
                )
            ];

            const payload = {
                name: "theo_doi_khach_bhvv",
                sheets: [
                    {
                        name: "Theo dõi khách BHVV",
                        data: listExport
                    }
                ]
            };

            const res = await axiosService(
                "api/mysql/export/have-data",
                "POST",
                payload
            );

            if (res.data.code === 200 && res.data.data?.url) {
                window.open(res.data.data.url, "_blank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const tabItems = [
        {
            key: '1',
            label: 'Tổng quan',
            children: (
                <ReportBHVVOverview
                    table={rows}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '2',
            label: 'Chi tiết',
            children: (
                <ReportBHVVDetail
                    table={rowsDetail}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
    ];
    return (
        <div className={`${styles.background} report-page container-fluid`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                title={"Theo dõi BHVV"} type={"bhvv-flow"}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={[]}
                userAdmin={userAdmin}
                startOldDate={startOldDate} endOldDate={endOldDate}
                handleRangeDateOld={handleRangeDateOld}
                selectListUser = {selectListUser}
            />
            <Spin spinning={loading}>
                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={12}>
                        <div className="p-2" style={{ backgroundColor: "white" }} >
                            <Tabs defaultActiveKey="1" items={tabItems} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}
export default ReportBHVV